import XIcon from '../icons/XIcon';
import { Body } from '../Typography';
import { Box, Modal as MUIModal, styled } from '@mui/material';
import { fontWeight } from '../../theme/typography';
import { HFlex, VFlex } from '../FlexContainers';
import { LinkButton } from '../Buttons';
import { palette } from '../../theme/palette';

export const Root = styled(Box)``;

export const Modal = styled(MUIModal)`
  margin: 10px;
`;

export const ModalContent = styled(Box)`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 90vw;
  max-width: 400px;
  background-color: ${palette.custom.darkGrey};
  border: none;
  box-shadow:
    0px 8px 15px 0px rgba(0, 0, 0, 0.1),
    0px -8px 15px 0px rgba(0, 0, 0, 0.1);
  border-radius: 5px;
  padding: 24px;
  :focus-visible {
    outline: 0;
  }
`;

export const ContentWrapper = styled(Box)`
  max-height: 95vh;
  overflow-y: auto;
`;

export const Contents = styled(VFlex)`
  margin-bottom: 30px;
`;

export const Title = styled(Body)`
  font-size: 18px;
  line-height: 22px;
  letter-spacing: 0.45px;
  font-weight: ${fontWeight.bold};
  color: ${palette.custom.white};
  margin-bottom: 14px;
  text-transform: capitalize;
`;

export const Description = styled(Body)`
  font-size: 15px;
  line-height: 22px;
  letter-spacing: 0.375px;
  color: ${palette.custom.white};
  font-weight: ${fontWeight.regular};

  &:not(:first-of-type) {
    margin-top: 12px;
  }

  p.para:not(:first-of-type) {
    margin-top: 12px;
  }

  *.bold {
    font-weight: ${fontWeight.bold};
  }
`;

export const Actions = styled(HFlex)`
  justify-content: flex-end;
`;

export const Confirm = styled(LinkButton)`
  cursor: pointer;
  font-size: 13.5px;
  font-weight: ${fontWeight.bold};
  color: ${palette.custom.white};
  font-size: 13.5px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  letter-spacing: 0.675px;
`;

export const Cancel = styled(LinkButton)`
  cursor: pointer;
  font-size: 13.5px;
  font-weight: ${fontWeight.bold};
  color: ${palette.custom.white};
  font-style: normal;
  line-height: normal;
  letter-spacing: 0.675px;
  padding-right: 32px;
`;

export const CloseButton = styled(Box)`
  cursor: pointer;
  position: absolute;
  top: 14px;
  right: 16px;
  height: 14px;
  width: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const CloseIcon = styled(XIcon)`
  color: ${palette.custom.grey};
  width: 14px;
  height: 14px;
  object-fit: contain;
`;
